/* sts-lcu-qty.js — every + , − and Remove in the LlamaCart drawer counts
   (STS-DRAWER-QTY-TAPS-1020). Loaded from layout/theme.liquid on every page;
   it does nothing until the app's drawer (#lcu-llama-cart) is in the page.

   Why: the app answers a quantity click by laying its loader over the
   stepper (z-index 2) and disabling every line's buttons — Remove included —
   until its write lands AND it has refetched the cart, ~1.3 s on a fast line.
   Any click in that window hit the loader or a disabled button and was
   dropped: live QA 2026-10-20 counted 2 of 3 "+" clicks lost on desktop, a
   shopper clicking about once a second loses every other one, and Remove
   clicked just after a "+" did nothing. (Its own counting could not take a
   second click either: it resets the chosen quantity to the cart's on every
   change.)

   So the theme counts. A click on a line's + / − / Remove is taken here
   (capture, on window, so the app never sees it): the line's wanted
   quantity moves by one (Remove: 0) and shows at once, and ONE write at a
   time sends the newest wanted quantity as an absolute number — clicks made
   while a write is out fold into the next write, nothing is applied twice.

   The writes go through window.fetch, which the app wraps (its snippet in
   the page): after every POST to /cart it re-reads the cart and the
   storefront cart, redraws, and runs its gift / reward rules — exactly what
   it does after its own change. Those redraws paint the half-way quantity,
   so while a line is pending its wanted number is put back on a short
   timer; once the last write's redraw has come, the row lets go. Without
   the wrapper (an app update), the app's own `_lcu.utils.refreshShopifyCart`
   is called instead.

   Busy state: the row gets aria-busy and data-sts-busy (price dimmed, a thin
   bar under the stepper); the buttons stay live. A typed quantity, the
   subscription switch and the app's own gift buttons are left to the app. */
(function () {
  'use strict';
  var w = window;
  var d = document;
  if (w.__stsLcuQty) return;
  w.__stsLcuQty = 1;

  var ROW = '.lcu__drawer__item';
  var lines = {};     // line key -> { had, want, gen }
  var writing = false;
  var gen = 0;        // bumps on every click; a refresh only clears lines it covered

  function sts() { return (w.STS = w.STS || {}); }
  sts().lcuQty = { lines: lines };   // read by the specs and by QA

  function root() {
    var r = w.Shopify && w.Shopify.routes && w.Shopify.routes.root;
    return typeof r === 'string' && r ? r.replace(/\/?$/, '/') : '/';
  }

  function style() {
    if (d.getElementById('sts-lcu-qty-css')) return;
    var s = d.createElement('style');
    s.id = 'sts-lcu-qty-css';
    var R = '#lcu-llama-cart ' + ROW;
    s.textContent =
      R + '[data-sts-busy] .lcu__product-prices{opacity:.45;transition:opacity .2s}' +
      R + '[data-sts-busy] .lcu__drawer__input-wrapper{position:relative}' +
      R + '[data-sts-busy] .lcu__drawer__input-wrapper::after{content:"";position:absolute;left:34%;right:34%;bottom:3px;height:2px;border-radius:2px;pointer-events:none;' +
        'background:currentColor;opacity:.35;animation:sts-lcu-busy 1s ease-in-out infinite alternate}' +
      R + '[data-sts-busy="rm"]{opacity:.45;transition:opacity .2s}' +
      '@keyframes sts-lcu-busy{from{transform:scaleX(.2)}to{transform:scaleX(1)}}' +
      '@media (prefers-reduced-motion:reduce){' + R + '[data-sts-busy] .lcu__drawer__input-wrapper::after{animation:none}}';
    (d.head || d.documentElement).appendChild(s);
  }

  /* Which of the line's controls a click is on: { kind, key, row } or null. */
  function control(t) {
    var app = d.getElementById('lcu-llama-cart');
    if (!app || !t || !t.closest || !app.contains(t)) return null;
    var row = t.closest(ROW);
    var key = row && row.getAttribute('data-variant-key');
    if (!key) return null;
    if (t.closest('.lcu__drawer__btn-remove')) return { kind: 'rm', key: key, row: row };
    var b = t.closest('button');
    var wrap = b && b.parentNode;
    if (!wrap || !wrap.classList || !wrap.classList.contains('lcu__drawer__input-wrapper') || wrap.closest(ROW) !== row) return null;
    var bs = [].filter.call(wrap.children, function (c) { return c.tagName === 'BUTTON'; });
    if (bs.length < 2) return null;
    if (b === bs[0]) return { kind: 'dec', key: key, row: row };
    if (b === bs[bs.length - 1]) return { kind: 'inc', key: key, row: row };
    return null;
  }

  function input(row) { return row && row.querySelector('.lcu__drawer__input-wrapper input'); }

  function rowOf(key) {
    var app = d.getElementById('lcu-llama-cart');
    if (!app) return null;
    var rows = app.querySelectorAll(ROW);
    for (var i = 0; i < rows.length; i++) if (rows[i].getAttribute('data-variant-key') === key) return rows[i];
    return null;
  }

  /* The quantity the row shows now, or what is already wanted for it. */
  function current(key, row) {
    if (lines[key]) return lines[key].want;
    var n = parseInt(input(row) && input(row).value, 10);
    return isNaN(n) ? null : n;
  }

  function paint(key) {
    var L = lines[key];
    var row = rowOf(key);
    if (!L || !row) return;
    var busy = L.want === 0 ? 'rm' : '';
    if (row.getAttribute('aria-busy') !== 'true') row.setAttribute('aria-busy', 'true');
    if (row.getAttribute('data-sts-busy') !== busy) row.setAttribute('data-sts-busy', busy);
    var i = input(row);
    if (i && L.want > 0 && String(i.value) !== String(L.want)) i.value = L.want;
  }

  function unpaint(key) {
    var row = rowOf(key);
    if (!row) return;
    row.removeAttribute('aria-busy');
    row.removeAttribute('data-sts-busy');
  }

  /* The app redraws the rows on its own cart updates (another script's write,
     say); put the wanted quantities back over the cart's. */
  function repaint() {
    (w.requestAnimationFrame || setTimeout)(function () {
      Object.keys(lines).forEach(paint);
    });
  }

  function post(key, quantity) {
    return w.fetch(root() + 'cart/change.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    }).then(function (r) {
      return r.json().catch(function () { return null; }).then(function (j) {
        if (!r.ok || !j) throw { description: (j && (j.description || j.message)) || '', status: r.status };
        return j;
      });
    }, function () {
      throw { name: 'TypeError', message: 'Failed to fetch' };
    });
  }

  function say(err) {
    var S = sts();
    var m = S.shopperError ? S.shopperError(err) : 'We could not update your cart.';
    if (S.ui && S.ui.toast) S.ui.toast(m, { role: 'alert' });
  }

  /* The app's fetch wrapper redraws after each write by itself. */
  function wrapped() {
    var app = w.lca_regal_upsells;
    return !!(app && app.isFetchOverwritten);
  }

  /* Its redraw after our newest write (debounced 100 ms), or 2 s. */
  function redrawn() {
    return new Promise(function (ok) {
      var t = setTimeout(done, 2000);
      function done() { clearTimeout(t); d.removeEventListener('upsell:cart-updated', done); ok(); }
      d.addEventListener('upsell:cart-updated', done);
    });
  }

  /* Without the wrapper (an app update): one refetch, through the app. */
  function refetch() {
    var u = w._lcu && w._lcu.utils;
    if (!u || typeof u.refreshShopifyCart !== 'function') return Promise.resolve();
    return Promise.resolve().then(function () { return u.refreshShopifyCart(); }).catch(function () {});
  }

  /* While a line is pending, the app may redraw it (its own redraw after our
     write, the storefront cart a moment later): keep the wanted number up. */
  var holdTimer = 0;
  function hold() {
    if (holdTimer) return;
    holdTimer = setInterval(function () {
      var keys = Object.keys(lines);
      if (!keys.length) { clearInterval(holdTimer); holdTimer = 0; return; }
      keys.forEach(paint);
    }, 100);
  }

  /* All lines caught up: once the app has the cart, the rows let go — only
     the lines no click has touched since. */
  function settle(seen) {
    var upTo = gen;
    seen.then(function () {
      (w.requestAnimationFrame || setTimeout)(function () {
        Object.keys(lines).forEach(function (k) {
          var L = lines[k];
          if (L.gen <= upTo && L.want === L.had) { delete lines[k]; unpaint(k); }
        });
        if (Object.keys(lines).length) next();
      });
    });
  }

  var seen = null;    // the app's update after the newest write
  function next() {
    if (writing) return;
    var key = null;
    Object.keys(lines).some(function (k) { if (lines[k].want !== lines[k].had) { key = k; return true; } return false; });
    if (key === null) { settle(seen || (wrapped() ? Promise.resolve() : refetch())); seen = null; return; }
    var L = lines[key];
    var q = L.want;
    writing = true;
    var sent = post(key, q);
    seen = wrapped() ? sent.then(redrawn, function () { /* no redraw after a failed write */ }) : null;
    sent.then(function (cart) {
      var it = (cart.items || []).filter(function (i) { return i.key === key; })[0];
      var got = it ? it.quantity : 0;
      L.had = got;
      /* The store gave fewer than asked (the last bottles): that is the line now. */
      if (got < q && L.want >= q) L.want = got;
      if (got < q) say({ description: 'Only ' + got + (got === 1 ? ' item was' : ' items were') + ' added to your cart due to availability.' });
    }, function (err) {
      /* Nothing more for any line; the app's redraw shows the cart as it is. */
      Object.keys(lines).forEach(function (k) { lines[k].want = lines[k].had; });
      say(err);
    }).then(function () {
      writing = false;
      paint(key);
      next();
    });
  }

  function onClick(e) {
    var c = control(e.target);
    if (!c) return;
    var now = current(c.key, c.row);
    if (now === null) return;
    /* A line on its way out takes no more clicks. */
    if (lines[c.key] && lines[c.key].want === 0) { e.preventDefault(); e.stopPropagation(); return; }
    var want = c.kind === 'rm' ? 0 : c.kind === 'inc' ? now + 1 : Math.max(0, now - 1);
    e.preventDefault();
    e.stopPropagation();
    if (want === now) return;
    style();
    var L = lines[c.key] || (lines[c.key] = { had: now, want: now, gen: 0 });
    L.want = want;
    L.gen = ++gen;
    paint(c.key);
    hold();
    next();
  }

  w.addEventListener('click', onClick, true);
  ['upsell:cart-updated', 'upsell:storefront-cart-updated', 'lcu:smart-cart:updated'].forEach(function (n) { d.addEventListener(n, repaint); });
})();
